
import React from "react";
import { Typography } from "@mui/material";
import Button from "../../components/button";
import MarqueeGallery from "./components/marqueeGallery";
import "./assets/welcome.css"; // import the CSS file

function Welcome() {
  return (
    <section className="page-section welcome-section">
      <div className="container">
        <div className="welcome-container">
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Bienvenido a Nuestra Iglesia
            </Typography>
            <Typography variant="h2">
              Somos una iglesia cristiana comprometida con la Palabra de Dios,
              sirviendo a la comunidad de la 9 de Enero con amor, fe y
              esperanza.
            </Typography>
          </div>

          <div className="welcome-buttons">
            <Button title={"Visitanos"} className={"secondary-cta-btn"} />
            <Button title={"Nosotros"} className={"about-btn"} />
          </div>
        </div>
      </div>

      {/* Marquee Gallery at the bottom */}
      <div>
        <MarqueeGallery />
      </div>
    </section>
  );
}

export default Welcome;
